import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

import { LocaleMap } from '@libs/src/locale/locale-map.interface';

const suffixes: LocaleMap = {
  'en-US': { few: 'rd', one: 'st', other: 'th', two: 'nd' },
  es: { other: 'o' },
  'fr-CA': { other: 'e' },
  ja: { other: '番目' },
  ko: { other: '번째' },
};

@Pipe({ name: 'ordinal', standalone: true })
export class OrdinalPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: keyof LocaleMap) {}

  transform(n: number, keepNumber = true) {
    const ordinalRules = new Intl.PluralRules(this.locale, { type: 'ordinal' });
    const selection = ordinalRules.select(n);
    const localeSuffixes = suffixes[this.locale] ?? suffixes['en-US'];
    const suffix = localeSuffixes[selection] ?? localeSuffixes.other;
    return `${'en-US' === this.locale && !keepNumber ? '' : n}${suffix}`;
  }
}
